import React, { forwardRef, memo } from 'react'

const ToolIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="47.6"
      height="48.3"
      viewBox="0 0 47.6 48.3"
      fill="none"
      {...props}>
      <circle cx="23.8" cy="24.4853" r="23.8" fill="#78BE20" />
      <g
        stroke="white"
        strokeWidth="2.259"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M22.0837 23.4557L24.8298 26.2018" />
        <path d="M32.3868 22.0772L28.949 25.515" />
        <path d="M16.2483 18.9931l1.1817-1.2212c.7013-.7014 1.5342-1.2578 2.4502-1.6374a7.22 7.22 0 0 1 5.7704 0c.916.3796 1.7489.936 2.4502 1.6374l5.7866 5.8261c.1286.1286.2009.3033.2009.4853s-.0723.3567-.2009.4854l-2.4595 2.4621a.685.685 0 0 1-.4853.2009.685.685 0 0 1-.4853-.2009l-3.2344-3.2319-8.7242 8.7241a.685.685 0 0 1-.4853.2009.685.685 0 0 1-.4853-.2009l-1.7756-1.7731a.685.685 0 0 1-.2009-.4853c0-.182.0723-.3567.2009-.4853l8.7242-8.7241-4.8246-4.8271" />
      </g>
    </svg>
  )
)

ToolIcon.displayName = 'ToolIcon'

export default memo(ToolIcon)
